import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import PrimaryPathwayIllustration from './PrimaryPathwayIllustration.js';
import Variant1PathwayIllustration from './Variant1PathwayIllustration.js';
import Variant2PathwayIllustration from './Variant2PathwayIllustration.js';
import Variant3PathwayIllustration from './Variant3PathwayIllustration.js';
import Variant4PathwayIllustration from './Variant4PathwayIllustration.js';
import Variant5PathwayIllustration from './Variant5PathwayIllustration.js';
import Variant6PathwayIllustration from './Variant6PathwayIllustration.js';
import Variant7PathwayIllustration from './Variant7PathwayIllustration.js';
import Variant8PathwayIllustration$1 from './Variant8PathwayIllustration.js';
import Variant8PathwayIllustration from './Variant9PathwayIllustration.js';
import Variant10PathwayIllustration from './Variant10PathwayIllustration.js';
import Variant11PathwayIllustration from './Variant11PathwayIllustration.js';
import Variant12PathwayIllustration from './Variant12PathwayIllustration.js';
import Variant13PathwayIllustration from './Variant13PathwayIllustration.js';
import Variant14PathwayIllustration from './Variant14PathwayIllustration.js';
import Variant15PathwayIllustration from './Variant15PathwayIllustration.js';
import Variant16PathwayIllustration from './Variant16PathwayIllustration.js';
import Variant17PathwayIllustration from './Variant17PathwayIllustration.js';
import Variant18PathwayIllustration from './Variant18PathwayIllustration.js';
import Variant19PathwayIllustration from './Variant19PathwayIllustration.js';
import Variant20PathwayIllustration from './Variant20PathwayIllustration.js';
import Variant21PathwayIllustration from './Variant21PathwayIllustration.js';
import Variant22PathwayIllustration from './Variant22PathwayIllustration.js';

const PathwayIllustration = /*#__PURE__*/ forwardRef(({ variant, color }, ref)=>{
    let renderIllustration;
    switch(variant){
        case 'variant1':
            renderIllustration = jsx(Variant1PathwayIllustration, {
                ref: ref,
                color: color
            });
            break;
        case 'variant2':
            renderIllustration = jsx(Variant2PathwayIllustration, {
                ref: ref,
                color: color
            });
            break;
        case 'variant3':
            renderIllustration = jsx(Variant3PathwayIllustration, {
                ref: ref,
                color: color
            });
            break;
        case 'variant4':
            renderIllustration = jsx(Variant4PathwayIllustration, {
                ref: ref,
                color: color
            });
            break;
        case 'variant5':
            renderIllustration = jsx(Variant5PathwayIllustration, {
                ref: ref,
                color: color
            });
            break;
        case 'variant6':
            renderIllustration = jsx(Variant6PathwayIllustration, {
                ref: ref,
                color: color
            });
            break;
        case 'variant7':
            renderIllustration = jsx(Variant7PathwayIllustration, {
                ref: ref,
                color: color
            });
            break;
        case 'variant8':
            renderIllustration = jsx(Variant8PathwayIllustration$1, {
                ref: ref,
                color: color
            });
            break;
        case 'variant9':
            renderIllustration = jsx(Variant8PathwayIllustration, {
                ref: ref,
                color: color
            });
            break;
        case 'variant10':
            renderIllustration = jsx(Variant10PathwayIllustration, {
                ref: ref,
                color: color
            });
            break;
        case 'variant11':
            renderIllustration = jsx(Variant11PathwayIllustration, {
                ref: ref,
                color: color
            });
            break;
        case 'variant12':
            renderIllustration = jsx(Variant12PathwayIllustration, {
                ref: ref,
                color: color
            });
            break;
        case 'variant13':
            renderIllustration = jsx(Variant13PathwayIllustration, {
                ref: ref,
                color: color
            });
            break;
        case 'variant14':
            renderIllustration = jsx(Variant14PathwayIllustration, {
                ref: ref,
                color: color
            });
            break;
        case 'variant15':
            renderIllustration = jsx(Variant15PathwayIllustration, {
                ref: ref,
                color: color
            });
            break;
        case 'variant16':
            renderIllustration = jsx(Variant16PathwayIllustration, {
                ref: ref,
                color: color
            });
            break;
        case 'variant17':
            renderIllustration = jsx(Variant17PathwayIllustration, {
                ref: ref,
                color: color
            });
            break;
        case 'variant18':
            renderIllustration = jsx(Variant18PathwayIllustration, {
                ref: ref,
                color: color
            });
            break;
        case 'variant19':
            renderIllustration = jsx(Variant19PathwayIllustration, {
                ref: ref,
                color: color
            });
            break;
        case 'variant20':
            renderIllustration = jsx(Variant20PathwayIllustration, {
                ref: ref,
                color: color
            });
            break;
        case 'variant21':
            renderIllustration = jsx(Variant21PathwayIllustration, {
                ref: ref,
                color: color
            });
            break;
        case 'variant22':
            renderIllustration = jsx(Variant22PathwayIllustration, {
                ref: ref,
                color: color
            });
            break;
        default:
            renderIllustration = jsx(PrimaryPathwayIllustration, {
                ref: ref,
                color: color
            });
            break;
    }
    return renderIllustration;
});

export { PathwayIllustration as default };
